import { Yup } from 'shared/lib'

export const createServiceSchema = Yup.object().shape({
   name: Yup.string().min(3).max(32).required(),
   defaultNetPrice: Yup.number().min(0).required(),
   defaultGrossPrice: Yup.number().min(0).required(),
   taxRate: Yup.number().min(0).required(),
})
